import { useContext } from "react"

import { tableContext } from "../utils"

export function useVariants() {
  const {
    selectedVariant,
    hoverVariant,
    headerVariant,
    strippedVariant,
    borderVariant,
    bordered,
    rowLines,
    colLines,
    stripped,
    selectable,
    collapsible,
    scrollable,
    verticallyScrollable,
    horizontallyScrollable,
    numCols,
    autoFit,
  } = useContext(tableContext)

  return {
    $selectedVariant: selectedVariant,
    $hoverVariant: hoverVariant,
    $headerVariant: headerVariant,
    $strippedVariant: strippedVariant,
    $borderVariant: borderVariant,
    $bordered: bordered,
    $rowLines: rowLines,
    $colLines: colLines,
    $stripped: stripped,
    $selectable: selectable,
    $collapsible: collapsible,
    $scrollable: scrollable,
    $verticallyScrollable: verticallyScrollable,
    $numCols: numCols,
    $autoFit: autoFit,
    $horizontallyScrollable: horizontallyScrollable,
  }
}
